import { getFullLocale, type SiteScope } from '$lib/js/helpers/i18n'
import { gt } from 'svelte-i18n-lingui'

/**
 * Transform an ISO datetime string into a human-friendly date string.
 */
export function datetimeToDate(datetime: string, { scope }: { scope: SiteScope }) {
	return new Date(datetime).toLocaleDateString(scope)
}

/**
 * Transform an ISO datetime string into a human-friendly date string.
 */
export function formatDatetime(datetime: string, { scope }: { scope: SiteScope }) {
	return new Intl.DateTimeFormat(getFullLocale(scope), {
		dateStyle: 'short',
		timeStyle: 'short',
	}).format(new Date(datetime + 'Z'))
}

function formatDateString(date: Date) {
	const day = date.getDate(),
		month = date.getMonth() + 1,
		dd = day < 10 ? '0' + day : '' + day,
		mm = month < 10 ? '0' + month : '' + month

	return date.getFullYear() + '-' + mm + '-' + dd + ' 00:00:00'
}

/**
 * Get today's date
 */
export function getTodaysDate() {
	let date = new Date()
	return formatDateString(date)
}

/**
 * Get next month's date
 */
export function getNextMonthsDate() {
	let date = new Date()
	date.setDate(date.getDate() + 30) // Add 30 days (FIXME: doesn't work on 31 January)
	return formatDateString(date)
}

/**
 * Format 'time ago' string.
 */
export function timeAgo(date: string) {
	// @ts-ignore
	const seconds = Math.floor((new Date() - new Date(date)) / 1000)

	let interval = Math.floor(seconds / 31536000)
	if (interval > 1) {
		return gt`${interval} years ago`
	}

	interval = Math.floor(seconds / 2592000)
	if (interval > 1) {
		return gt`${interval} months ago`
	}

	interval = Math.floor(seconds / 86400)
	if (interval > 1) {
		return gt`${interval} days ago`
	}

	interval = Math.floor(seconds / 3600)
	if (interval > 1) {
		return gt`${interval} hours ago`
	}

	interval = Math.floor(seconds / 60)
	if (interval > 1) {
		return gt`${interval} minutes ago`
	}

	if (seconds < 10) return gt`now`

	return Math.floor(seconds) + ' ' + gt`seconds`
}